module.exports = __webpack_public_path__ + "static/img/swiper3.be674392.webp";